import { useModelPreferences } from "@/hooks/useModelPreferences"
import { useModelAccount } from "@/hooks/useModelAccount"
import { useModelUser } from "@/hooks/useModelUser"

export function useModel() {
  const account = useModelAccount()
  const preferences = useModelPreferences()
  const user = useModelUser()
  return { Account: account, Preferences: preferences, User: user }
}
